<div class="page">
  <app-page-header 
    itemName="" 
    page-title="{{ property.get('name') }}"
    isPropertyHome = "true"
    hideList = "{{ loggedUserShared }}"
  >
  </app-page-header>
  <div class="page-content">
    <div class="alert alert-danger text-center mb-4" *ngIf="propertyData && !propertyData.active">
      {{ 'properties.detail.suspended_property_alert' | translate }}
    </div>

    <!-- DETAIL CARD -->
    <mat-card class="custom-card">
      <mat-card-title>{{ 'properties.detail.editTab.title' | translate }}
      </mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="detailCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <app-creator-updator-box [data]="property"></app-creator-updator-box>
          <div class="form-wrapper mt-3">
            <form [formGroup]="form" (ngSubmit)="onFormSubmit(1)">
              <formly-form [form]="form" [fields]="anagraphicFields" [model]="model" [options]="options"></formly-form>
              <formly-form *ngIf="loggedUserAdmin" [form]="formChangeAdmin" [fields]="changeAdminFields" [model]="modelChangeAdmin" [options]="optionsChangeAdmin"></formly-form>
              <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate">
              </mat-spinner-button>
            </form>
          </div>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- CONTRACT CARD -->
    <mat-card class="custom-card mt-4"
      *ngIf="model && model.subscription && loggedUserPermissions.includes('canCreateSubscriptions')"
      [ngClass]="{'d-none': loggedUserMaster}">
      <mat-card-title>{{ 'companies.fields.subscription.titleSection' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="detailCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="form-wrapper mt-3">
            <div class="alert alert-primary text-center mb-4">
              <mat-slide-toggle class="toggle-activation-btn" color="accent" [checked]="enableEdit"
                (change)="onToggleSelected($event)" matTooltipPosition="right"
                matTooltip="{{ 'companies.detail.contractTab.toggleTooltip' | translate }}">
                <mat-label>{{ 'companies.detail.contractTab.toggleLabel' | translate }}</mat-label>
              </mat-slide-toggle>
            </div>
            <form [formGroup]="formSC" (ngSubmit)="onFormSubmit(2)">
              <formly-form [form]="formSC" [fields]="contractFields" [model]="modelSC" [options]="options"></formly-form>
              <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate">
              </mat-spinner-button>
            </form>
          </div>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- CONTRACT CARD MASTER-->
    <mat-card class="custom-card mt-4"  *ngIf="loggedUserMaster && !masterOnlySuppliersAndNfcTag && !masterOnlySuppliers && !masterOnlyNfcTag">
      <mat-card-title>{{ 'companies.fields.subscription.titleSection' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="detailCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="form-wrapper mt-3">
            <form [formGroup]="formSC">
              <formly-form [form]="formSC" [fields]="contractFields" [model]="modelSC" [options]="options"></formly-form>
            </form>
          </div>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->